module.exports = __webpack_public_path__ + "img/dt-logo-vertical-white-text.3f398e77.svg";